import React from 'react';
import { RouterLink } from 'components/CommonUi/RouterLink';
import { InstrumentationOptions } from 'types';
import {
    CtaGoal,
    CtaType,
    InteractionSource,
} from 'utils/analytics/AnalyticsV2Service.generated';
import { analytics } from 'utils/analytics';
import { RIGHTWARDS_ARROW } from '../../../constants/entities';
import { useGenericCarouselContext } from '../GenericCarouselContext';
import { GenericCarouselHeading } from '../GenericCarousel.styled';

export const Title = () => {
    const { carouselName, carouselId, carouselUrl, linkLocation } =
        useGenericCarouselContext();

    const titleUrl = linkLocation === 'Title' ? carouselUrl : undefined;

    // ANALYTICS
    const instrumentationOptions: InstrumentationOptions = {
        goal: 'Show More',
        interactionSource: `Title ${carouselName}`,
        ...(carouselName && { 'L - Carousel Name': carouselName }),
        ...(carouselId && { 'L - Carousel ID': carouselId }),
    };

    return (
        <RouterLink
            to={titleUrl}
            instrumentationOptions={instrumentationOptions}
            onClick={() => {
                analytics.trackCTAClicked({
                    ctaGoal: CtaGoal.ShowMore,
                    ctaType: CtaType.PlainText,
                    interactionSource: InteractionSource.TextAction,
                    ctaDestination: titleUrl || undefined,
                    ctaText: carouselName,
                });
            }}
        >
            <GenericCarouselHeading
                as="h5"
                size="xl"
                mb="4px"
                data-testid="carousel-title"
            >
                {carouselName}
                {titleUrl && RIGHTWARDS_ARROW}
            </GenericCarouselHeading>
        </RouterLink>
    );
};
